import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import basicScienceFacultyData from "./facultyData/basicScienceFacultyData";

const departmentOverview = {
  paragraphs: [
    "",
  ],
};

const chemistryFacultyNames = {
  "f-sneha-s-kulkarni": "Dr. Sneha.S. Kulkarni",
  "f-vinod-naik": "Dr. Vinod. Naik",
  "f-g-s-kurdekar": "Dr. Gurunath. Kurdekar",
};

const facultyOrder = [
  "f-sneha-s-kulkarni",
  "f-g-s-kurdekar",
  "f-vinod-naik",
];

const getOrderedFacultyMembers = (members = []) => [
  ...facultyOrder
    .map((id) => members.find((faculty) => faculty.id === id))
    .filter(Boolean),
  ...members.filter((faculty) => !facultyOrder.includes(faculty.id)),
];

const chemistryFacultyData = {
  hod: null,
  members: getOrderedFacultyMembers(
    [
      basicScienceFacultyData.hod,
      ...basicScienceFacultyData.members,
    ].filter((faculty) => Object.keys(chemistryFacultyNames).includes(faculty.id))
  )
    .map((faculty) => ({
      ...faculty,
      name: chemistryFacultyNames[faculty.id],
      ...(faculty.id === "f-sneha-s-kulkarni"
        ? {
            designation: "Assistant Professor",
            role: "Assistant Professor",
          }
        : {}),
    })),
};

export const programme = {
  id: "chemistry",
  name: "Chemistry",
  short: "Chemistry",
  programmeType: "ug",
  programmeLabel: "",
  duration: "First-year engineering foundation",
  intake: "510+",
  established: 2004,
  description:
    "The Chemistry department offers Engineering Chemistry as a core subject for all first-year engineering students. The curriculum covers physical, organic, and inorganic chemistry topics directly linked to real-world engineering applications including corrosion, water treatment, polymers, fuels, and electrochemistry.",
  departmentOverview,
  dashboard: [
    ["Faculty Members", "03"],
    ["Faculty with Ph.D.", "03"],
    ["Laboratories", "01"],
    ["Students Enrolled", "510+"],
  ],
  academicOverview: [
    {
      title: "Academic Strengths",
      text: "The department has experienced faculty, modern laboratories, and strong mentoring support.Students consistently perform well in VTU examinations and engage in research activities.Industry interaction, value education, and professional ethics support overall development"
    },
    {
      title: "Practical Learning and Innovation",
      text: "The department blends engineering chemistry theory with laboratory work, material testing, water analysis, and applied experiments.",
    },
    {
      title: "Beyond Syllabus",
      text: "Students connect chemistry foundations with materials, sustainability, polymers, fuels, corrosion control, and engineering applications.",
    },
  ],
  programmesOffered: {
    title: "Course Details",
    description:
      "Engineering Chemistry course structure for first-year B.E. students.",
    columns: ["Attribute", "Details"],
    rows: [
      [
        "Course Offered",
        "Engineering Chemistry (1BCHEM102/202, 1BCHEC102/202, 1BCHEE102/202, 1BCHES102/202) as per VTU scheme.",
      ],
      ["Semester", "I & II (First Year B.E.)"],
      ["Credits", "4 (3 Theory + 1 Lab)"],
      ["Laboratory", "Engineering Chemistry Lab"],
      [
        "Key Topics",
        "Electrochemistry, Corrosion & Corrosion Control, Polymers, Fuels & Combustion, Engineering Materials, Instrumental Methods of Analysis, Sensors.",
      ],
      ["Faculty Strength", "3"],
      ["Ph.D. Holders", "3"],
      [
        "Research Areas",
        "Green Chemistry, Nano-catalysis, Polymer Synthesis, Environmental Chemistry, Coordination compounds.",
      ],
    ],
  },
  image: "/Academics/chemisty.jpg",
  facultyDeptId: "bsh",
  facultyData: chemistryFacultyData,
  labs: ["Engineering Chemistry Lab"],
  research: "Green Chemistry | Nano-catalysis | Polymer Synthesis | Coordination Compounds | Environmental Chemistry",
  accreditation: ["VTU-affiliated first-year curriculum", "AICTE-approved engineering programme support"],
  achievements: [
    {
      title: "Achievement Documents",
      items: [
        { label: "Chemistry Achievements", href: "#" },
      ],
    },
  ],
  courseOutcomes: {
    title: "Course Outcomes (COs) - Engineering Chemistry (1BCHEE102/202)",
    columns: ["CO No.", "Course Outcome"],
    rows: [
      [
        "CO1",
        "Interpret the principles of chemistry related to engineering and technology.",
      ],
      [
        "CO2",
        "Apply the knowledge of chemistry in solving engineering problems related to energy, materials, corrosion, analytical techniques and environmental contexts.",
      ],
      [
        "CO3",
        "Analyze the appropriate chemical techniques suitable for engineering applications to reach the substantiated conclusions.",
      ],
      [
        "CO4",
        "Apply the techniques of quantitative chemical analysis for engineering problems through experimental skills.",
      ],
    ],
  },
  projects: [],
};

const Chemistry = () => <ProgrammeDetail programme={programme} />;

export default Chemistry;
